import {
  Breadcrumbs,
  Inline,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useEmployee, useGetExpense } from '@omnipresentgroup/domains';
import {
  ExpenseDetails,
  ExpenseDetailsCutOffNotification,
} from '@omnipresentgroup/features';
import { isExpensePending } from '@omnipresentgroup/types';
import { useNavigate, useParams } from 'react-router';

import { EXPENSES_PATH, HOME_PATH } from '../../constants';
import { ExpenseActions } from '../../features/expenses';
import { EXPENSES_PAGE_TITLE } from './Expenses';

const EXPENSES_DETAILS_PAGE_TITLE = 'Expense details';
const REJECTION_MESSAGE =
  'You have rejected the expense for the following reason:';
const REQUESTED_CHANGE_MESSAGE = 'You have requested a change to the expense:';

export const ExpenseDetailsPage = () => {
  const navigate = useNavigate();
  const { expenseId } = useParams<{ expenseId: string }>();

  const { data: expense } = useGetExpense({
    expenseId,
  });

  const { data: employee, isSuccess: isSuccessEmployee } = useEmployee({
    id: expense?.employeeId,
    enabled: !!expense?.employeeId,
  });

  const PageHeader = () => (
    <Inline
      justify="space-between"
      minH={40}
      align="center"
      css={{ flexWrap: 'wrap' }}
    >
      <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
        {EXPENSES_DETAILS_PAGE_TITLE}
      </Typography>
      {expenseId && <ExpenseActions expenseId={expenseId} />}
    </Inline>
  );

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            {
              id: 'home',
              title: 'Home',
              onClick: () => navigate(HOME_PATH),
            },
            {
              id: 'expenses',
              title: EXPENSES_PAGE_TITLE,
              onClick: () => navigate(EXPENSES_PATH),
            },
            {
              id: 'expense-details',
              title: EXPENSES_DETAILS_PAGE_TITLE,
              active: true,
            },
          ]}
        />
        <PageHeader />
      </Stack>

      {isExpensePending(expense) && isSuccessEmployee && (
        <ExpenseDetailsCutOffNotification
          legalEntityId={employee?.legalEntityId || ''}
        />
      )}

      {expenseId && (
        <ExpenseDetails
          expenseId={expenseId}
          rejectionMessage={REJECTION_MESSAGE}
          requestedChangeMessage={REQUESTED_CHANGE_MESSAGE}
        />
      )}
    </>
  );
};
